<template>
    <div>
        <base-header type="gradient-green" class="pb-6 pb-8 pt-5 pt-md-8">
          <div class="row col-12 text-white text-center d-center">

          </div>
        </base-header>

        <div class="container-fluid mt--6">
            <div class="row">
                <div class="col">
                    <tabela-parametros title="Parâmetros - Elementos da Ficha"></tabela-parametros>
                </div>
            </div>
        </div>

    </div>
</template>
<script>
  import TabelaParametros from '@/views/Parametros/TabelaParametros'
  export default {
    name: 'tables',
    components: {
      TabelaParametros
    }
  };
</script>
<style></style>
